module.exports = __webpack_public_path__ + "static/img/map-dummy.39d4f2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/map-dummy.png
// module id = OVL8
// module chunks = 46